import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function OButton({ to, href, children, variant = "primary", className = "", icon = false, ...rest }) {
  const styles = {
    primary: "bg-invert text-invert-ink hover:opacity-90",
    secondary: "glass-heavy text-ink hover:bg-hairline/[0.08] hover:border-hairline/20",
    accent: "bg-oraya-accent text-white hover:opacity-90",
    ghost: "text-ink hover:text-subtle",
  };
  const cls = `inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-medium transition-all duration-300 ${styles[variant]} ${className}`;
  const inner = (
    <>
      {children}
      {icon && <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />}
    </>
  );
  if (to) return <Link to={to} className={`group ${cls}`} {...rest}>{inner}</Link>;
  if (href) return <a href={href} className={`group ${cls}`} {...rest}>{inner}</a>;
  return <button className={`group ${cls}`} {...rest}>{inner}</button>;
}
